// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1YA9W","logo":"styles_logo__3FF1B","loginRadio":"styles_loginRadio__3p2R2","forgetMe":"styles_forgetMe__1HM82"};